import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { Title } from '@angular/platform-browser'
import { Router } from '@angular/router'
import { lastValueFrom } from 'rxjs'

import { ButtonComponent } from '../../components/button/button.component'
import { AuthService } from '../../services/auth.service'
import { getTitle } from '../../util/accessibility'
import { MfaMethodType } from '../../../_generated/graphql'
import { UserService } from '../../services/user/user.service'

@Component({
  selector: 'app-mfa-method-select-page',
  standalone: true,
  imports: [MatIcon, ButtonComponent],
  templateUrl: './mfa-method-select-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mfa-method-select-page.component.scss',
})
export class MfaMethodSelectPageComponent implements OnInit {
  methods: MfaMethodType[] = []
  constructor(
    private users: UserService,
    private authService: AuthService,
    private router: Router,
    title: Title,
  ) {
    title.setTitle(getTitle('多要素認証の登録方法'))
  }
  async backToLogin(): Promise<void> {
    await this.authService.signOutPreservingReturnUrl()
    this.authService.redirectToLogin()
  }
  async ngOnInit(): Promise<void> {
    try {
      const status = await lastValueFrom(this.users.getMfaStatus())
      if (!status.requiredForUser || status.methods.length > 0) {
        await this.router.navigateByUrl(
          this.authService.consumeReturnUrl() || '/home',
        )
        return
      }
      this.methods = status.enrollableMethods.filter(
        (method) =>
          method === MfaMethodType.Sms ||
          method === MfaMethodType.Totp ||
          method === MfaMethodType.Passkey,
      )
      if (this.methods.length === 0)
        throw new Error('No enrollable MFA methods')
      if (this.methods.length === 1 && this.methods[0] === MfaMethodType.Sms)
        await this.select(MfaMethodType.Sms)
    } catch {
      alert('登録方法を取得できませんでした。再度ログインしてください。')
      await this.backToLogin()
    }
  }
  async select(method: MfaMethodType): Promise<void> {
    if (!this.methods.includes(method)) return
    await this.router.navigate([
      method === MfaMethodType.Passkey
        ? '/auth/passkey-setup'
        : method === MfaMethodType.Sms
          ? '/auth/phone-setup'
          : '/auth/totp-setup',
    ])
  }
}
